import { Component, OnInit, Signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthApiService } from '@core/services/api/auth.api.service';
import { BranchService } from '@core/services/helpers/branch.service';
import { BreakpointService } from '@core/services/layout/breakpoint.service';
import { TimeTickerService } from '@core/services/helpers/time-ticker.service';
import { ZoomService } from '@core/services/helpers/zoom.service';
import { UserRole } from '@core/models/enums/user.enum';
import { ProfileApiService } from '@core/services/api/profile.api.service';
@Component({
  selector: 'gus-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  readonly userRole = UserRole;
  readonly zoomLoading: Signal<boolean>;
  constructor(
    private router: Router,
    private breakPointService: BreakpointService,
    private authApi: AuthApiService,
    private branchService: BranchService,
    private timeTickerService: TimeTickerService,
    private zoomService: ZoomService,
    private profileApi: ProfileApiService
  ) {
    this.zoomLoading = this.zoomService.loading;
  }

  ngOnInit(): void {
    this.breakPointService.checkBreakpoints();
    this.timeTickerService.startInterval();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (this.authApi.userType() === this.userRole.instructor) {
          this.profileApi.getInstructor().pipe().subscribe();
        }

        if (this.authApi.getAccessToken()) {
          const path = this.branchService.path();
          if (path === 'booking-event') {
            const data = this.branchService.branchData();
            const deepLinkData = data?.data_parsed as {
              $deeplink_path: string;
              $custom_meta_tags: { bookingEventId: string };
            };

            const url = this.authApi.isInstructor() ? `/my-activity/details/` : `/live/`;
            this.router.navigate([`${url}${deepLinkData.$custom_meta_tags.bookingEventId}`]);
          }
        }
      }
    });
  }
}
